module.exports = __webpack_public_path__ + "img/dinner_available.3f893eda.jpg";